import axios from 'axios';
import Cookies from 'js-cookie';

const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json',
        'x-api-key': `${process.env.VUE_APP_API_KEY}`
    },
});

apiClient.interceptors.request.use(config => {
    const token = Cookies.get('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

const ApiService = {
    async post(url, data) {
        try {
            const response = await apiClient.post(url, data);
            if(response.data.status == 200){
                return { success: true, data: response.data };
            }
            return { success: false, data: {error: response.data.error, status: response.data.status} };
        } catch (error) {
            const userInfo = Cookies.get('user_info');
            console.log(error)
            if(error.response.status === 401 && userInfo){
                Cookies.remove('user_info');
                Cookies.remove('access_token');
                window.location.reload();
            }
            return { success: false, error: error.response ? error.response.data : error.message };
        }
    },

    async get(url) {
        try {
            const response = await apiClient.get(url);
            return { success: true, data: response.data };
        } catch (error) {
            const userInfo = Cookies.get('user_info');
            if(error.response.status === 401 && userInfo){
                Cookies.remove('user_info');
                Cookies.remove('access_token');
                window.location.reload();
            }
            return { success: false, error: error.response ? error.response.data : error.message };
        }
    },

    async put(url, data) {
        try {
            const response = await apiClient.put(url, data);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: error.response ? error.response.data : error.message };
        }
    },

    async delete(url) {
        try {
            const response = await apiClient.delete(url);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: error.response ? error.response.data : error.message };
        }
    }
};

export default ApiService;
